import { IComponent } from "./IComponent";

export type ChipModel = IComponent & {
  Label: string;
  Color?: ChipColor;
  Variant?: ChipVariant;
};

export enum ChipVariant {
  Filled = "Filled",
  Outlined = "Outlined",
}

export enum ChipColor {
  Default = "Default",
  Primary = "Primary",
  Secondary = "Secondary",
  Success = "Success",
  Error = "Error",
  Warning = "Warning",
  Info = "Info",
}
